"use client";

import { useQuery } from "@tanstack/react-query";
import apiFetch from "@/lib/fetch";

interface VenueCompany {
  id: number;
  discount: number;
}

interface VenueCompaniesResponse {
  data: VenueCompany[];
}

export function useVenueCompanyMaxDiscount(
  venueId: number,
  enabled = true,
): number | null {
  const { data } = useQuery<VenueCompaniesResponse>({
    queryKey: ["venue-company-max-discount", venueId],
    queryFn: () => apiFetch({ route: `company/venue/${venueId}?index=0` }),
    enabled: enabled && !!venueId,
    staleTime: 1000 * 60 * 60,
  });

  const companies = data?.data;
  if (!Array.isArray(companies) || companies.length === 0) return null;

  const discounts = companies
    .map((c) => Number(c.discount))
    .filter((d) => Number.isFinite(d) && d > 0);

  if (discounts.length === 0) return null;
  return Math.max(...discounts);
}
